/**
 * Base class to retrieve geographical data of countries.
 *
 * An instance of this class represents a country, so you will need to create the instance
 * by giving a valid country code (alhpa 2 code) of a country.
 */
class Geolocation {
  constructor(countryCode) {
    this.countryCode = countryCode;
  }

  /**
   * Returns an array of cities of this country ordered alphabetically.
   */
  cities() {
    return fetch(`/professionals/api/expert_profile_locations/cities_by_country?country=${this.countryCode}`)
      .then((data) => data.json())
      .then((data) => data);
  }
}

export default Geolocation;
